import { FILTER_PAGE_ALL_EVENT } from './constants'

export const filterPageAllEvent = (page = '', event = null) => ({
  type: FILTER_PAGE_ALL_EVENT,
  page,
  event,
})
